import { ref, reactive, toRefs } from 'vue'

export let loading = ref(false)

export default {
  loading
}
